import { useState } from "react";
import { createInvoiceItem } from "../../api/invoiceService";

export const useCreateInvoiceItem = (successCallback) => {
  const [creating, setCreating] = useState(false);
  const create = async (data) => {
    setCreating(true);
    try {
      const newRecord = await createInvoiceItem(data);
      setCreating(false);
      if (successCallback)
      {
        successCallback(newRecord);
      }
        return newRecord;
    } catch (error) {
      setCreating(false);
      console.error("Failed to create invoice item:", error);
      throw error; // rethrow so the component can handle errors
    }
  };

  return { create, creating };
};